module.exports = __webpack_public_path__ + "static/media/download.aebcc39f.svg";